import $ from "jquery";

const errorFormSubmit = (el) => {
    const $el = $(el);

    const $iframeContainer = $el.find('.greencon-integration__iframe-container');
    const $iframe = $iframeContainer.find('iframe');
    $iframe.attr('height', '1377px'); //default height

    if($iframe) {
        $(window).on("message", (e) => {
            if (e.originalEvent.data === "form_submitted") {
                $('html, body').animate({ scrollTop: 0 }, 'smooth');
                $iframe.attr('height', '400px'); //after submit height
            }
        });
    }

};
export default errorFormSubmit;
